import { render, staticRenderFns } from "./TechnicalResourcesDocu.vue?vue&type=template&id=6513fae8&scoped=true"
import script from "./TechnicalResourcesDocu.vue?vue&type=script&lang=js"
export * from "./TechnicalResourcesDocu.vue?vue&type=script&lang=js"
import style0 from "./TechnicalResourcesDocu.vue?vue&type=style&index=0&id=6513fae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6513fae8",
  null
  
)

export default component.exports